(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westy-home-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  var track = document.getElementById('wh-track');
  if (track) {
    var step = function(){ return Math.min(track.clientWidth * 0.8, 640); };
    var next = document.getElementById('wh-next');
    var prev = document.getElementById('wh-prev');
    if (next) next.onclick = function(){ track.scrollBy({ left: step(), behavior: 'smooth' }); };
    if (prev) prev.onclick = function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); };
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function(res){ return res.json().then(function(data){ return { ok: res.ok, data: data }; }); })
        .then(function(result){
          if (!result.ok) throw new Error((result.data && result.data.description) || 'Could not add to cart');
          btn.textContent = 'Added';
          return fetch('/cart.js').then(function(r){ return r.json(); });
        })
        .then(function(cart){
          var cartNEl = document.getElementById('wh-cartN');
          if (cartNEl) cartNEl.textContent = cart.item_count;
        })
        .catch(function(){
          btn.textContent = 'Try again';
        })
        .finally(function(){
          setTimeout(function(){ btn.textContent = original; }, 1400);
        });
    });
  });

  document.querySelectorAll('.wh-home .card .photo').forEach(function(photo){
    var slides = photo.querySelectorAll('.slide-img');
    if (slides.length < 2) return;
    var idx = 0;
    var timer = null;
    photo.addEventListener('mouseenter', function(){
      if (timer) return;
      timer = setInterval(function(){
        idx = (idx + 1) % slides.length;
        slides.forEach(function(s, i){ s.classList.toggle('is-active', i === idx); });
      }, 900);
    });
    photo.addEventListener('mouseleave', function(){
      if (timer) { clearInterval(timer); timer = null; }
      idx = 0;
      slides.forEach(function(s, i){ s.classList.toggle('is-active', i === 0); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westy-home-collection"]) return;
  try {
    
(function(){
  document.querySelectorAll('.wh-cat-card .photo').forEach(function(photo){
    var slides = photo.querySelectorAll('.slide-img');
    if (slides.length < 2) return;
    var idx = 0;
    var timer = null;
    photo.addEventListener('mouseenter', function(){
      if (timer) return;
      timer = setInterval(function(){
        idx = (idx + 1) % slides.length;
        slides.forEach(function(s, i){ s.classList.toggle('is-active', i === idx); });
      }, 900);
    });
    photo.addEventListener('mouseleave', function(){
      if (timer) { clearInterval(timer); timer = null; }
      idx = 0;
      slides.forEach(function(s, i){ s.classList.toggle('is-active', i === 0); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westy-home-compare-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  var slider = document.getElementById('wh-cmp-slider');
  if (!slider) return;
  var handle = document.getElementById('wh-cmp-handle');
  var dragging = false;

  function setPos(clientX){
    var rect = slider.getBoundingClientRect();
    var pct = ((clientX - rect.left) / rect.width) * 100;
    pct = Math.max(0, Math.min(100, pct));
    slider.style.setProperty('--pos', pct + '%');
    handle.setAttribute('aria-valuenow', Math.round(pct));
    handle.setAttribute('aria-valuetext', Math.round(pct) + '% chocolate side');
  }

  slider.addEventListener('pointerdown', function(e){
    if (e.target.closest('a')) return;
    dragging = true;
    slider.setPointerCapture(e.pointerId);
    setPos(e.clientX);
  });
  slider.addEventListener('pointermove', function(e){
    if (!dragging) return;
    setPos(e.clientX);
  });
  slider.addEventListener('pointerup', function(){ dragging = false; });
  slider.addEventListener('pointercancel', function(){ dragging = false; });

  handle.addEventListener('keydown', function(e){
    var current = parseFloat(slider.style.getPropertyValue('--pos'));
    if (!Number.isFinite(current)) current = 50;
    if (e.key === 'ArrowLeft'){ current = Math.max(0, current - 5); }
    else if (e.key === 'ArrowRight'){ current = Math.min(100, current + 5); }
    else if (e.key === 'Home'){ current = 0; }
    else if (e.key === 'End'){ current = 100; }
    else { return; }
    e.preventDefault();
    slider.style.setProperty('--pos', current + '%');
    handle.setAttribute('aria-valuenow', Math.round(current));
    handle.setAttribute('aria-valuetext', Math.round(current) + '% chocolate side');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westy-home-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var mobile = document.getElementById('wh-mobile');
  var burger = document.getElementById('wh-burger');
  var closeM = document.getElementById('wh-closeM');
  var previousOverflow = '';
  function closeMenu(restoreFocus) {
    if (!mobile || !mobile.classList.contains('open')) return;
    mobile.classList.remove('open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = previousOverflow;
    if (restoreFocus) burger.focus();
  }
  if (mobile && burger) burger.onclick = function(){
    previousOverflow = document.body.style.overflow;
    mobile.classList.add('open');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeM.focus();
  };
  if (mobile && closeM) closeM.onclick = function(){ closeMenu(true); };
  if (mobile) {
    mobile.querySelectorAll('a').forEach(function(a){ a.onclick = function(){ closeMenu(false); }; });
    mobile.addEventListener('keydown', function(event){
      if (event.key === 'Escape') { event.preventDefault(); closeMenu(true); return; }
      if (event.key !== 'Tab') return;
      var controls = Array.from(mobile.querySelectorAll('button, a[href]')).filter(function(el){ return el.getClientRects().length; });
      var first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    window.matchMedia('(min-width: 921px)').addEventListener('change', function(event){ if (event.matches) closeMenu(false); });
  }

  document.addEventListener('shopify:cart:lines-update', function(event){
    if (!event.promise) return;
    event.promise.then(function(result){
      var count = result.cart ? result.cart.totalQuantity : result.detail && result.detail.itemCount;
      if (typeof count !== 'number') return;
      var label = document.getElementById('wh-cartN');
      if (label) label.textContent = String(count);
    }).catch(function(){});
  });

  document.querySelectorAll('.wh-home .has-menu > .dropdown-trigger').forEach(function(trigger){
    trigger.addEventListener('click', function(e){
      if (window.matchMedia('(hover: none)').matches) {
        e.preventDefault();
        trigger.parentElement.classList.toggle('open');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westy-home-homepage"] && !Shopify.designMode) return;
  try {
    
(function(){
  var heroCopy = document.getElementById('wh-heroCopy');
  if (heroCopy) {
    window.addEventListener('load', function(){ heroCopy.classList.add('in'); });
  }

  var track = document.getElementById('wh-track');
  if (track) {
    var step = function(){ return Math.min(track.clientWidth * 0.8, 640); };
    var next = document.getElementById('wh-next');
    var prev = document.getElementById('wh-prev');
    if (next) next.onclick = function(){ track.scrollBy({ left: step(), behavior: 'smooth' }); };
    if (prev) prev.onclick = function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); };
  }

  var cartN = document.getElementById('wh-cartN');
  document.querySelectorAll('[data-add-to-cart]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function(res){ return res.json().then(function(data){ return { ok: res.ok, data: data }; }); })
        .then(function(result){
          if (!result.ok) throw new Error((result.data && result.data.description) || 'Could not add to cart');
          btn.textContent = 'Added';
          return fetch('/cart.js').then(function(r){ return r.json(); });
        })
        .then(function(cart){
          if (cartN) cartN.textContent = cart.item_count;
        })
        .catch(function(){
          btn.textContent = 'Try again';
        })
        .finally(function(){
          setTimeout(function(){ btn.textContent = original; }, 1400);
        });
    });
  });

  var mobile = document.getElementById('wh-mobile');
  var burger = document.getElementById('wh-burger');
  var closeM = document.getElementById('wh-closeM');
  if (mobile && burger) burger.onclick = function(){ mobile.classList.add('open'); };
  if (mobile && closeM) closeM.onclick = function(){ mobile.classList.remove('open'); };
  if (mobile) mobile.querySelectorAll('a').forEach(function(a){ a.onclick = function(){ mobile.classList.remove('open'); }; });
})();

  } catch(e) { console.error(e); }
})();
})();
